export const createUploadFormMockSchema = () => {
  return {
    type: 'object',
    required: ['technologist name', 'date of birth', 'acquisition date'],
    properties: {
      'technologist name': {
        type: 'string',
      },
      'date of birth': {
        type: 'string',
        format: 'date-month',
      },
      'acquisition date': {
        type: 'string',
        format: 'date',
      },
    },
  };
};

export const createUploadFormMockUiSchema = () => {
  return {
    type: 'VerticalLayout',
    elements: [
      {
        type: 'Control',
        scope: '#/properties/date of birth',
        options: {
          format: 'date',
          dateFormat: 'yyyy-MM',
          minDate: '01-1900',
          maxDate: 'currentDate',
        },
      },
      {
        type: 'Control',
        scope: '#/properties/acquisition date',
        options: {
          format: 'date',
          dateFormat: 'yyyy-MM-dd',
          minDate: '01-01-1900',
          maxDate: 'currentDate',
        },
      },
      {
        type: 'Control',
        scope: '#/properties/technologist name',
      },
    ],
  };
};
